package com.zaurh.portfolio.main

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.animateIntAsState
import androidx.compose.foundation.clickable
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shadow
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.TextUnit
import com.zaurh.portfolio.utils.getPoppinsFont

@Composable
fun HeaderText(
    title: String,
    textUnit: TextUnit,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    val color by animateColorAsState(
        targetValue = if (isSelected)
            MaterialTheme.colorScheme.tertiary
        else
            MaterialTheme.colorScheme.primary.copy(alpha = 0.75f),
        label = "color"
    )

    val shadowBlur by animateFloatAsState(
        targetValue = if (isSelected) 6f else 0f,
        label = "shadow"
    )

    Text(
        text = title,
        color = color,
        fontFamily = getPoppinsFont(),
        fontSize = textUnit,
        style = TextStyle(
            shadow = Shadow(
                color = color,
                blurRadius = shadowBlur
            )
        ),
        modifier = Modifier
            .pointerHoverIcon(PointerIcon.Hand)
            .clickable(
                indication = null,
                interactionSource = remember { MutableInteractionSource() }
            ) {
                onClick()
            }
    )
}